import { Link } from "react-router-dom";
import { useWishlist } from "@/context/WishlistContext";
import { PRODUCTS } from "@/lib/products";
import { ProductCard } from "@/components/product/ProductCard";
import { Heart, ChevronRight } from "lucide-react";

export default function Wishlist() {
  const { ids, clear } = useWishlist();
  const items = PRODUCTS.filter((p) => ids.includes(p.id));

  return (
    <div data-testid="wishlist-page" className="container-nc py-12">
      <div className="flex items-center gap-2 text-xs text-muted_brown mb-6">
        <Link to="/" className="hover:text-espresso">Home</Link>
        <ChevronRight size={12} />
        <span className="text-espresso">Wishlist</span>
      </div>

      <div className="flex items-end justify-between flex-wrap gap-3 mb-10">
        <div>
          <p className="overline mb-2">Saved for later</p>
          <h1 className="font-serif text-5xl md:text-6xl text-espresso">Your Wishlist</h1>
          <p className="text-muted_brown mt-3">
            {items.length === 0
              ? "Nothing saved yet — start collecting your favorites."
              : `${items.length} item${items.length > 1 ? "s" : ""} you're considering.`}
          </p>
        </div>
        {items.length > 0 && (
          <button
            onClick={clear}
            data-testid="wishlist-clear"
            className="text-xs uppercase tracking-[0.15em] text-muted_brown hover:text-espresso border-b border-line hover:border-espresso pb-1"
          >
            Clear wishlist
          </button>
        )}
      </div>

      {items.length === 0 ? (
        <div className="bg-ivory border border-line rounded-2xl p-16 text-center">
          <div className="w-14 h-14 rounded-full border border-line flex items-center justify-center mx-auto mb-5">
            <Heart size={20} strokeWidth={1.5} className="text-gold" />
          </div>
          <h3 className="font-serif text-2xl text-espresso">Save your favorites</h3>
          <p className="text-muted_brown text-sm mt-2 max-w-md mx-auto">
            Tap the heart icon on any product to save it here for later.
          </p>
          <Link to="/shop" className="btn-primary mt-8 inline-flex">Browse Products</Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-6 gap-y-12">
          {items.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
